import axios from '@/libs/api.request';

export const addOrderPaybackPackageFee = data => {
    return axios.request({
        url: 'api/financeManagement/packageFee/addOrderPaybackPackageFee',
        data: data,
        method: 'post'
    });
};

export const getOrderPaybackPackageFeeList = data => {
    return axios.request({
        url: 'api/financeManagement/packageFee/getOrderPaybackPackageFeeList',
        data: data,
        method: 'post'
    });
};

export const approvalOrderPaybackPackageFee = data => {
    return axios.request({
        url: 'api/financeManagement/packageFee/approvalOrderPaybackPackageFee',
        data: data,
        method: 'post'
    });
};

export const cancelOrderPaybackPackageFee = data => {
    return axios.request({
        url: 'api/financeManagement/packageFee/cancelOrderPaybackPackageFee',
        data: data,
        method: 'post'
    });
};
